import { getAuthHeader } from "../tokenStorage";
import { axiosInstance } from "./axiosInstance";

export const getAttendanceByProgram = async (programId) => {
  return axiosInstance.get(`/blapi/attendance/get/${programId}`, {
    headers: getAuthHeader(),
  });
};
